export abstract class PricesDataSharedService {
    abstract getConfiguratorPricesForPriceVersionSync(
        priceVersion: number,
        contractorCompanyId?: number | null,
        serverProps?: {
            project: string;
            companyId: number;
            language: string;
            contractorCompanyId?: number | null;
            activeMarketId?: number | null;
        }
    );

    abstract getPriceRastersForPriceVersionSync(
        priceVersion: number,
        serverProps?: {
            project: string;
            companyId: number;
            language: string;
            contractorCompanyId?: number | null;
            activeMarketId?: number | null;
        }
    );

    getPricesRevisionsForPriceVersionSync(
        priceVersion: number,
        configuratorId?: string | null,
    ): { prices: number; priceRasters: number } {
        return { prices: 0, priceRasters: 0 };
    }
}
